<template>
  <div class="mainDetail coverPre">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/main' }">当前位置：组织列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="obpm-fromContent-title obpm-enterpriseDomain-logo clearfix">
      <el-row class="normalLineH">
        <el-col :span="12">
          <span class="toolbar-title">组织信息</span>
        </el-col>
        <el-col :span="12" style="text-align:right">
          <span class="toolbar-buttons">
            <el-button type="primary" @click="onSave" size="small">{{$t('save')}}</el-button>
            <el-button @click="$emit('exit')" size="small" type="primary" plain>{{$t('exit')}}</el-button>
          </span>
        </el-col>
      </el-row>

      <el-form
        ref="form"
        :model="content"
        label-position="top"
        label-width="180px"
        size="mini"
        :rules="rules"
      >
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="组织名称" class="padding0Label" prop="name">
              <el-input v-model="content.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" :offset="4">
            <el-form-item label="Logo(60 x 60)：" class="padding0Label">
              <input type="hidden" name="content.logoUrl" value />

              <input type="hidden" id="logo" name="content.logoUrl" value />
              <div :class="haveImg" style="border:1px solid #e6e6e6">
                <img
                  style="display:block;"
                  id="_iconImg"
                  alt
                  :src="content.logoUrl"
                  class="adminLogoImg"
                />
              </div>

              <el-button class="obpm-btn-default mr-1" plain @click="selectIcon">选择</el-button>
              <el-button type="danger" plain @click="cleanIcon">清除</el-button>
            </el-form-item>
          </el-col>
          <!-- <el-col :span="6" :offset="4">
            <el-form-item label="选择皮肤" class="padding0Label" prop="skinType">
              <el-select v-model="content.skinType" placeholder="选择皮肤" class="el-select-w">
                <el-option v-for="(elm,index) in skins" :key="index" :label="elm" :value="elm"></el-option>
              </el-select>
            </el-form-item>
          </el-col> -->
        </el-row>
        <!-- <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="百保盾短信平台帐号" class="marginBot0">
              <el-input v-model="content.smsMemberCode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" :offset="4">
            <el-form-item label="百保盾短信平台密码" class="marginBot0">
              <el-input type="password" v-model="content.smsMemberPwd"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4" :offset="0">
            <el-form-item class="marginTop29 marginBot0">
              <el-button
                type="primary"
                plain
                class="obpm-btn obpm-btn-default"
                @click="testSMS"
              >测试短信发送</el-button>
            </el-form-item>
          </el-col>
        </el-row> -->
        <!-- <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item class="padding0Label">
              <a
                href="http://sms.teemlink.com/sms/register/register.jsp"
                target="_blank"
                class="tip-text"
              >[还没有帐号?]</a>
            </el-form-item>
          </el-col>
          <el-col :span="6" :offset="4">
            <el-form-item class="padding0Label">
              <a
                href="http://sms.teemlink.com/sms/"
                target="_blank"
                class="tip-text"
              >[修改密码?请登录百保盾短信平台！]</a>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="系统名称" class="padding0Label">
              <el-input v-model="content.systemName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" :offset="4">
            <el-form-item label="描述" class="padding0Label">
              <el-input type="textarea" autosize v-model="content.description"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="是否激活" class="padding0Label">
              <el-switch v-model="status" :active-value="true" :inactive-value="false"></el-switch>
            </el-form-item>
          </el-col>          
        </el-row>
      </el-form>
    </div>
    <icon_select
      :visible.sync="iconSelectCheck"
      :logoUrl="content.logoUrl"
      @select-ok="onSelectIconOk"
      v-if="iconSelectCheck"
    />
  </div>
</template>

<script>
import icon_select from "@/components/icon_select.vue";

export default {
  components: {
    icon_select,
  },
  created() {
    this.$api.getSkins({
      onSucess: (resp) => {
        this.skins = resp.data.data;
        this.skins.forEach((elm, index) => {
          if (elm == "vue") {
            this.skins.splice(index, 1);
          }
        });
        this.content.skinType = this.skins[0];
      },
    });
  },
  data() {
    var nameCheck = (rule, value, callback) => {
      let re = /[^a-zA-Z0-9_\u4e00-\u9fa5]/;
      if (!value) {
        return callback(new Error("域(租户)名称不能为空"));
      } else if (re.test(value)) {
        return callback(new Error("域(租户)名称不能含有特殊字符"));
      } else {
        return callback();
      }
    };
    return {
      content: {
        name: "",
        systemName: "",
        smsMemberCode: "",
        smsMemberPwd: "",
        description: "",
        status: 1,
        // skinType: "",
        logoUrl: "",
      },
      logoUrl: "img",
      iconSelectCheck: false,
      fontIconColor: "#000000",
      skins: [],
      rules: {
        name: [
          { required: true, message: "请先填写域(租户)名称", trigger: "blur" },
          {
            validator: nameCheck,
            message: "域(租户)名称不能含有特殊字符",
            trigger: "blur",
          },
        ],
        // skinType: [
        //   { required: true, message: "请先选择皮肤", trigger: "blur" },
        // ],
      },
      haveImg: "noLogo",
    };
  },
  computed: {
    status: {
      get() {
        return this.content.status == 1;
      },
      set(value) {
        this.content.status = value ? 1 : 0;
      },
    },
  },
  methods: {
    onSave() {
      if (this.content.name == "") {
        this.$message({
          message: "请填写域(租户)名称!",
          type: "error",
        });
        return false;
      }
      if (this.logoUrl == "icon") {
        this.content.logoUrl = this.content.logoUrl + this.fontIconColor;
      }
      this.$api.createDomain(this.content, {
        onSucess: (resp) => {
          if (resp && resp.data.errcode == 0) {
            this.$message({
              message: this.$t('msg_save_success'),
              type: "success",
            });
            this.$emit("exit");
          } else {
            this.$message({
              message: resp.data.errmsg,
              type: "error",
            });
          }
        },
      });
    },
    testSMS() {
      this.$prompt("请输入手机号码", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^1\d{10}$/,
        inputErrorMessage: "手机号码格式不正确",
      })
        .then(({ value }) => {
          this.$api.testSMS(this.content.id, value, {
            onSucess: (resp) => {
              if (resp && resp.data.data.type == "success") {
                this.$message({
                  message: "发送成功",
                  type: "success",
                });
              } else {
                this.$message({
                  message: "发送失败",
                  type: "error",
                });
              }
            },
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    selectIcon() {
      this.iconSelectCheck = true;
    },
    onSelectIconOk(item) {
      if (item) {
        if (item.path) {
          this.logoUrl = "img";
          this.content.logoUrl = this.$api.getLogoUrl(item.path);
          this.haveImg = "adminLogo";
        } else if (item.filePath) {
          this.logoUrl = "img";

          this.content.logoUrl = this.$api.getLogoUrl(item.filePath);
          this.haveImg = "adminLogo";
        } else {
          this.$message({
            type: "error",
            message: "选择失败",
          });
        }
      }
    },
    cleanIcon() {
      this.content.logoUrl = "";
      this.haveImg = "noLogo";
    },
  },
};
</script>
<style scoped>
@import "../assets/css/font-awesome.min.css";
</style>
<style lang="scss" scoped>
</style>